import React, {useCallback, useEffect, useState} from 'react';
import {Box, Modal} from "@material-ui/core";
import {fetchScoreCardDetails} from "../live.view.api.services";
import {toast} from "react-toastify";
import {mapScoreCardDetails} from "../live.view.data.services";
import LoadingOverlay from "react-loading-overlay";

const ScoreCardDetailsModal = React.memo(({open, handleClose, scoreCardId,golferDetails}) => {

    const [scoreCardDetails, setScoreCardDetails] = useState(null)
    const [loading, setLoading] = useState(false)


    const fetchScoreCard = useCallback(async () => {
        try {
            setLoading(false)
            const payload = {
                scorecard_id: scoreCardId
            }
            const res = await fetchScoreCardDetails(payload)
            const scoreCardData = mapScoreCardDetails(res.data.data)
            setScoreCardDetails(scoreCardData)
        } catch (e) {
            const error = e.response?.data?.errMsg;
            toast.error(error)
        } finally {
            setLoading(false)
        }

    }, [scoreCardId])

    useEffect(() => {
        if (open && scoreCardId) {
            fetchScoreCard()
        } else {
            setScoreCardDetails(null)
        }
    }, [open, scoreCardId])


    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            shouldCloseOnOverlayClick={true}
className={"popup_modal"}



        >
            {/*<>*/}
                <Box>
                {/* */}
                {/*</Box>*/}

                <Box sx={style}>
{/*<div className="contant">*/}
                    <LoadingOverlay
                        active={loading}
                        spinner
                        text='Loading....'
                    >

                        <div className="scorecard_header">
                            <span></span>
                            <span className="text-jost-sb-22">{golferDetails.name}</span>
                        <div className="close_btn_score_modal">
                            <button onClick={handleClose}>X</button>
                        </div>
                        </div>
                        <table className="live-view_table live_score" style={{backgroundColor: "#fff"}}>
                            <tr className="live-view_table_head">
                                <th className="table__row-0">Hole</th>
                                <th className="table__row-0">Start Time</th>
                                <th className="table__row-0">Finish Time</th>
                                <th className="table__row-0">Score</th>
                                <th className="table__row-0">Points</th>
                            </tr>

                        {
                            scoreCardDetails?.length

                                ?

                                scoreCardDetails?.map(_scorecard => (

                                    <tr>
                                        <td className="score_data" >
                                            <span>{_scorecard.holeIndex}</span>
                                            <span>PAR : {_scorecard.yardsPar.par}</span>
                                            <span>YD : {_scorecard.yardsPar.yards}</span>
                                            <span>STROKE INDEX : {_scorecard.yardsPar.stroke_index}</span>
                                        </td>
                                        <td style={{
                                            color: "red",
                                            fontSize: "1.7rem"
                                        }}>{_scorecard.startTime?.split('T')[1].split('.')[0]}</td>
                                        <td style={{
                                            color: "red",
                                            fontSize: "1.7rem"
                                        }}>{_scorecard.finishTime?.split('T')[1].split('.')[0]}</td>
                                        <td style={{color: "red", fontSize: "1.7rem"}}>{(_scorecard.score===-1)?'NR':_scorecard.score}</td>
                                        <td style={{color: "red", fontSize: "1.7rem"}}>{_scorecard.points}</td>

                                    </tr>
                                ))

                                :

                                <tr>
                                    <td colSpan='5'>
                                        <div style={{minHeight: "15rem"}}/>
                                    </td>
                                </tr>

                        }

                    </table>
                </LoadingOverlay>

            </Box>
            {/*</>*/}
            {/*</div>*/}
                </Box>
        </Modal>
    );
});

export default ScoreCardDetailsModal;


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    backgroundColor: "#fff",
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    // padding: 6,
    borderRadius: 5,
    height: "50vh",
    overflow: "hidden",
    overflowX: "hidden",
    overflowY: 'scroll',
    paddingTop: 0,
    paddingRight: 0,
    paddingLeft: 0

};
